/* T.LUXY V18: move the stock app's live notice BELOW the whole
   "Add to cart + Wishlist" row so it can never overlap the CTA or the heart.
   V17 only matched one wrapper (.mm-portal). V18 also finds the notice by its
   class names or by its text, and moves the outermost wrapper the app placed
   inside the purchase row. The app's node is moved, never cloned.
*/
(() => {
  'use strict';
  if (!document.body.classList.contains('template-product')) return;

  const STOCK_SELECTOR = '.hengan-low-stock-description, .lowStockDescriptionStyle, [class*="low-stock"], [class*="lowStock"], [class*="LowStock"]';
  const STOCK_TEXT = /(rimast[oi]|in magazzino|scorte|left in stock|only \d+ left|items? left)/i;
  const SAFE_SELECTOR = 'button, input, select, textarea, form, a[href], .product__submit__add, .wishlisthero-product-page-button-container';
  let pending = false;

  function setImp(el, name, value) {
    if (el.style.getPropertyValue(name) !== value || el.style.getPropertyPriority(name) !== 'important') {
      el.style.setProperty(name, value, 'important');
    }
  }

  // Elements inside the purchase area that carry the stock message.
  function findNotices(scope) {
    const SAFE = 'button, input, select, textarea, form, a[href], .product__submit__add, .wishlisthero-product-page-button-container';
    const found = new Set([...scope.querySelectorAll(STOCK_SELECTOR)].filter((el) => !el.querySelector(SAFE)));
    scope.querySelectorAll('p, span, div').forEach((el) => {
      if (el.closest('button, .tluxy-wishlist-slot, .tluxy-stock-note')) return;
      if (el.querySelector(SAFE)) return; // never move a container that holds the buttons
      if (el.children.length > 3) return;
      const text = (el.textContent || '').trim();
      if (text && text.length < 80 && STOCK_TEXT.test(text)) found.add(el);
    });
    // Keep only outermost matches.
    return [...found].filter((el) => ![...found].some((other) => other !== el && other.contains(el)));
  }

  // Climb to the wrapper whose parent is the purchase row or one of its cells.
  function outerWrapper(el, actions) {
    let node = el;
    while (node.parentElement && node.parentElement !== actions && !node.parentElement.matches('.tluxy-purchase-actions > *')) {
      node = node.parentElement;
      if (!actions.contains(node)) return el;
    }
    return node;
  }

  function rewriteCopy(box) {
    const textEl = [...box.querySelectorAll('p, span')].find((n) => /\d/.test(n.textContent) && n.children.length === 0) || box;
    const raw = (textEl.textContent || '').trim();
    const m = raw.match(/\b(\d+)\b/);
    const amount = m ? Number(m[1]) : Number(textEl.dataset.tluxyStockCount);
    if (!Number.isInteger(amount) || amount < 1) return;
    const it = (document.documentElement.lang || '').toLowerCase().startsWith('it');
    const copy = it
      ? (amount === 1 ? 'Ultimo articolo disponibile' : `Solo ${amount} articoli disponibili`)
      : (amount === 1 ? 'Last item available' : `Only ${amount} items available`);
    textEl.dataset.tluxyStockCount = String(amount);
    if (raw !== copy && textEl.children.length === 0) textEl.textContent = copy;
  }

  function style(box) {
    box.classList.add('tluxy-stock-note');
    ['position:static', 'transform:none', 'float:none', 'clear:both', 'width:100%', 'height:auto', 'margin:12px 0 26px', 'padding:0', 'inset:auto']
      .forEach((rule) => { const [k, v] = rule.split(':'); setImp(box, k, v); });
    box.querySelectorAll('svg, img').forEach((icon) => setImp(icon, 'display', 'none'));
    [box, ...box.querySelectorAll('*')].forEach((el) => {
      setImp(el, 'color', '#111111');
      setImp(el, 'font-size', '13px');
      setImp(el, 'font-weight', '600');
      setImp(el, 'line-height', '1.45');
      setImp(el, 'letter-spacing', '.02em');
      if (el !== box) { setImp(el, 'margin', '0'); setImp(el, 'padding', '0'); }
    });
    rewriteCopy(box);
  }

  function placeNotes() {
    document.querySelectorAll('.shopify-section--product .product__submit__holder').forEach((holder) => {
      const actions = holder.querySelector('.tluxy-purchase-actions');
      const row = actions || holder.querySelector('.product__submit__buttons') || holder.firstElementChild;
      if (!row) return;

      findNotices(row).forEach((notice) => {
        const box = outerWrapper(notice, row);
        if (box === row || box.querySelector(SAFE_SELECTOR)) return;
        row.insertAdjacentElement('afterend', box);
        style(box);
      });

      // Notices already moved (or injected right after the row): keep them styled.
      holder.querySelectorAll(':scope > .tluxy-stock-note').forEach((box) => {
        if (box.previousElementSibling !== row) row.insertAdjacentElement('afterend', box);
        style(box);
      });
    });
  }

  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; placeNotes(); });
  }

  schedule();
  document.addEventListener('DOMContentLoaded', schedule);
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
